const AUTH_PATHS = ['/login', '/sign-up', '/logout'];

/**
 * Accepts same-origin absolute URLs (strips the origin) and plain relative paths.
 * Rejects everything else to prevent open-redirect when the value comes from
 * an untrusted source like localStorage.
 * Also rejects auth-flow paths (/login, /sign-up) since redirecting
 * back to those after authentication creates an infinite loop.
 */
export const sanitizeRedirectUrl = (
  url: string | undefined,
  currentOrigin = window.location.origin,
): string | undefined => {
  if (!url) return undefined;

  if (url.startsWith('/') && !url.startsWith('//')) {
    const path = url.split('?')[0].split('#')[0];
    if (path === '/') return undefined;
    if (AUTH_PATHS.some((p) => path === p || path.startsWith(p + '/'))) return undefined;
    return url;
  }

  try {
    const parsed = new URL(url);
    if (parsed.origin === currentOrigin) {
      const path = parsed.pathname;
      if (AUTH_PATHS.some((p) => path === p || path.startsWith(p + '/'))) return undefined;
      return path + parsed.search + parsed.hash;
    }
  } catch {
    // not a parseable URL — fall through to reject
  }

  return undefined;
};
